<div
  class="file-field"
  [class.dragging-over]="draggingFileOver"
  (drop)="fileDrop($event)"
  (dragover)="fileAllowDrop($event)"
  (dragleave)="draggingFileOver = false"
>
  @if (draggingFileOver) {
    <div class="drop-area">Drop here</div>
  }

  @if (formControl.value?.length === 0 && !draggingFileOver) {
    <div class="add-file">
      <button #addFileButton class="bd-btn-icon-flat" (click)="fileInput.click()">
        <mat-icon svgIcon="icon_add_32" />
      </button>
      <span class="hint">Click + or drop file here</span>
    </div>
  }
  <div class="file-list">
    @for (file of filesFormControl.value; track file.fileUrl; let index = $index) {
      <img
        #filesRefs
        class="file-type"
        loading="lazy"
        [class.image]="isImageColumn"
        [class.readonly]="column.isComputed"
        [src]="file.imgIcon"
        [alt]="file.fileUrl"
        [blazeTooltip]="file.title"
        [matMenuTriggerFor]="menu"
        [attr.readonly]="column.isComputed ? true : null"
        [attr.data-tooltip]="file.title"
      />
      <mat-menu #menu="matMenu" class="bd-menu files-menu">
        <ng-template matMenuContent>
          <a
            mat-menu-item
            [href]="file.href"
            (click)="downloadFile($event, file.fileUrl, column.isSecure)"
            rel="noopener noreferrer"
            class="text-primary-lighter"
          >
            <mat-icon svgIcon="icon_download_16" />
            <span class="text-primary-darker">Download</span>
          </a>
          <a mat-menu-item (click)="fileRemove(index)" rel="noopener noreferrer" class="!text-warn">
            <mat-icon svgIcon="icon_trash_16" />
            <span class="!text-warn">Remove</span>
          </a>
        </ng-template>
      </mat-menu>
    }
  </div>
  @if (!!column.multipleValues && formControl.value?.length > 0 && !draggingFileOver) {
    <button #addFileButton blazeIconButton="secondary" class="mr-8" (click)="fileInput?.click()">
      <mat-icon svgIcon="icon_add_32" />
    </button>
  }
  <input
    #fileInput
    class="file-input"
    type="file"
    [accept]="acceptedFiletypes"
    [multiple]="!!column.multipleValues"
    (change)="fileSelected($event.target)"
    [class.readonly]="column.isComputed"
    [attr.readonly]="column.isComputed ? true : null"
  />
</div>
